import { data } from './client-program';

export const es = {
  data,
};
